angular.module('MW.InsDashboard.NavBarStateChangeService', [])
.factory('NavBarStateChangeService', [
    '$rootScope',
    function ($rootScope) {
        'use strict';

        var navigationConstants = Object.freeze({
            mwNavigationEventName: 'mw-navigation:size-toggle-complete',
            mwNavigationClassSelector: '.mw-app-container__navigation',
            mwNavigationHiddenClassName: 'xs-sm',
            redrawWidgetEventName: 'widgetResized'
        });

        var navBarStateChangeService = {},
            wasPreviouslyVisible = undefined;

        /**
         * Handles the size toggle event from the gaf-ng-components nav bar.
         */
        navBarStateChangeService.handleSizeToggleEvent = function ($scope){
            // as of 1-17-2018, this event is fired from within the navigation component of gaf-ng-components after the transition when the nav bar is expanded/collapsed
            //  we make use of this event to redraw our widget charts to fit the browser window when the nav bar opens/closes
            $rootScope.$on(navigationConstants.mwNavigationEventName, function (event, data) {
                if (!$scope.isMaximized)
                    return;

                var isNavBarVisible = !angular.element(navigationConstants.mwNavigationClassSelector).hasClass(navigationConstants.mwNavigationHiddenClassName);

                if (isNavBarVisible && wasPreviouslyVisible) {
                    $scope.$broadcast(navigationConstants.redrawWidgetEventName);
                }

                wasPreviouslyVisible = isNavBarVisible;
            });
        };

        return navBarStateChangeService;
    }
]);
